import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { DocumentIconComponent } from 'app/modules/GlobalComponents/document-icon.component';
import { AdministradorDePlantillasService } from '../administrador-de-plantillas.service';
import { UtilsService } from 'app/modules/utils-service';
import { Plantilla } from '../../../models/plantillas.model';

@Component({
    selector: 'agregar-nueva-plantilla',
    templateUrl: 'agregar-plantilla.component.html',
    imports:[
        CommonModule,
        MatButtonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule, 
        MatTableModule,

        //Componentes
        DocumentIconComponent,
    ]
})

export class AgregarPlantillaComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  isDraggingOver = false;
  documentos: File[] = [];
  nombreDocumento:string
  plantillaId:number
  seccionId: number;
  actualizarPlantilla:boolean= false
  //paginación de plantillas
  inicio:number = 0
  max:number = 10

  constructor(
    public dialogRef: MatDialogRef<AgregarPlantillaComponent>,
    private administradorDePlantillasService: AdministradorDePlantillasService,
    @Inject(MAT_DIALOG_DATA) public data:{plantilla?: Plantilla, actualizarPlantilla?:boolean },
    private utilsService: UtilsService,
    private route: ActivatedRoute,

  ) {
    if(this.data){
      this.actualizarPlantilla= this.data.actualizarPlantilla
      this.nombreDocumento= this.data.plantilla.nombreDocumento
      this.plantillaId= this.data.plantilla.plantillaId
    }
    
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const seccion = params['seccion'];
      this.seccionId = Number(seccion);
    });
  }
  

  uploadImage() {
    this.fileInput.nativeElement.click();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDraggingOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDraggingOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDraggingOver = false;
    if (event.dataTransfer?.files.length > 0) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.handleFiles(input.files);
    }
  }

  handleFiles(files: FileList): void {
    const file = files[0];
    
    const isValidType =
      file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      file.name.toLowerCase().endsWith('.docx');

    this.documentos = [file];
  }

  borrar(index: number) {
    this.documentos.splice(index, 1);
  }

  guardarPlantilla(): void {
    const file = this.documentos[0];

    const formData = new FormData();
    formData.append('nombreDocumento', this.nombreDocumento);
   
    if(this.actualizarPlantilla){
      formData.append('plantillaId', this.plantillaId.toString());
      this.administradorDePlantillasService.actualizaPlantilla(formData)
      .then(() => {
          this.administradorDePlantillasService.getPlantillas(this.seccionId, this.inicio, this.max)
          this.utilsService.openSuccessSnakBar('Se ha actualizado la plantilla correctamente');
          this.dialogRef.close(true);
        })

    }else{
        formData.append('file', file, file.name);
        formData.append('seccion', this.seccionId.toString());

        this.administradorDePlantillasService.postNuevaPlantilla(formData)
        .then(() => {
          this.administradorDePlantillasService.getPlantillas(this.seccionId, this.inicio, this.max)
          this.utilsService.openSuccessSnakBar('Se ha guardado la plantilla correctamente');
          this.dialogRef.close(true);
        })
    }

    
  }

}
